module.exports = __webpack_public_path__ + "img/DNARepair-GBM_GSE194329.8f75920c.png";